import Home from "@material-ui/icons/Home";
import Description from "@material-ui/icons/Description";
import Search from "@material-ui/icons/Search";
import TrackChanges from "@material-ui/icons/TrackChanges";
import EventNote from "@material-ui/icons/EventNote";
import Apartment from "@material-ui/icons/Apartment";
import DonutSmall from "@material-ui/icons/DonutSmall";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import EditIcon from "@material-ui/icons/Edit";
import BusinessIcon from "@material-ui/icons/Business";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import StoreIcon from "@material-ui/icons/Store";
import StorageIcon from "@material-ui/icons/Storage";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import DnsIcon from "@material-ui/icons/Dns";
import MicIcon from "@material-ui/icons/Mic";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import PollIcon from "@material-ui/icons/Poll";
import FolderSharedIcon from "@material-ui/icons/FolderShared";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import HomeIcon from "@material-ui/icons/Home";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import GroupIcon from "@material-ui/icons/Group";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import ContactsIcon from "@material-ui/icons/Contacts";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
import EventNoteIcon from "@material-ui/icons/EventNote";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import ListAltIcon from "@material-ui/icons/ListAlt";
import WorkIcon from "@material-ui/icons/Work";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import BookIcon from "@material-ui/icons/Book";
import FaceIcon from "@material-ui/icons/Face";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PersonalVideoIcon from "@material-ui/icons/PersonalVideo";
import GradeIcon from "@material-ui/icons/Grade";
import FilterIcon from "@material-ui/icons/Filter";
import HttpIcon from "@material-ui/icons/Http";
import ImportantDevicesIcon from "@material-ui/icons/ImportantDevices";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ImageIcon from "@material-ui/icons/Image";
import ReorderIcon from "@material-ui/icons/Reorder";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import consoleHome from "../console/HomePage";
import SaleObj from "../console/SaleObj";
import NewFavorite from "../console/NewFavorite";
import Calendar4 from "../console/Calendar4";
import ApartmentInf from "../console/ApartmentInf";
import Statistical from "../console/Statistical";
import ObjCheck from "../console/ObjCheck";
import BranchManage from "../console/BranchManage";
import FranchiseSystem from "../console/FranchiseSystem";
import ObjErrorReport from "../console/ObjErrorReport";
import ObjEditRecord from "../console/ObjEditRecord";
import HRmanage from "../console/HRmanage";
import AccountManage from "../console/AccountManage";
import OnlineUsers from "../console/OnlineUsers";
import RentObjManage from "../console/RentObjManage";
import RenterManage from "../console/RenterManage";
import SystemNotification from "../console/SystemNotification";
import NewInfo from "../console/NewInfo";
import CustomerCenter from "../console/CustomerCenter";
import MissCustomer from "../console/MissCustomer";
import CustomerAnalyze from "../console/CustomerAnalyze";
import CustomerStatistics from "../console/CustomerStatistics";
import MemberManage from "../console/MemberManage";
import Assignments from "../console/Assignments";
import PersonalMessage from "../console/PersonalMessage";
import LeaveApply from "../console/LeaveApply";
import PersonalCalendar from "../console/PersonalCalendar";
import VendorContact from "../console/VendorContact";
import WorkReport from "../console/WorkReport";
import BusinessReport from "../console/BusinessReport";
import StudentManage from "../console/StudentManage";
import SystemTeaching from "../console/SystemTeaching";
import CourseAnnouncement from "../console/CourseAnnouncement";
import SaleSecret from "../console/SaleSecret";
import CISArea from "../console/CISArea";
import FileShare from "../console/FileShare";
import ExclusiveWeb from "../console/ExclusiveWeb";
import SendRecord from "../console/SendRecord";
import PointsStore from "../console/PointsStore";
import ActivityAnnouncement from "../console/ActivityAnnouncement";
import PictureManage from "../console/PictureManage";
import CrawlerRecord from "../console/CrawlerRecord";
import ResetPassword from "../console/ResetPassword";

let dashRoutes = [
  {
    path: "/home",
    name: "首頁",
    icon: Home,
    component: consoleHome,
    layout: "/console",
    identities: ["STAFF", "FRANCHISEE"],
  },
  {
    collapse: true,
    name: "加盟系統",
    icon: GroupAddIcon,
    state: "pageCollapse",
    identities: ["STAFF"],
    views: [
      {
        path: "/branch-manage",
        name: "分店管理",
        icon: StoreIcon,
        component: BranchManage,
        layout: "/console",
      },
      {
        path: "/franchise-system",
        name: "加盟體系資料",
        icon: StorageIcon,
        component: FranchiseSystem,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "公告欄",
    icon: DeveloperBoardIcon,
    state: "pageCollapse1",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      {
        path: "/system-notification",
        name: "系統公告",
        icon: AnnouncementIcon,
        component: SystemNotification,
        layout: "/console",
      },
      {
        path: "/new-info",
        name: "最新消息",
        icon: DnsIcon,
        component: NewInfo,
        layout: "/console",
      },
      // {
      //   path: "/award-record",
      //   name: "採訪獲獎紀錄",
      //   icon: MicIcon,
      //   component: AwardRecord,
      //   layout: "/console",
      // },
    ],
  },
  {
    collapse: true,
    name: "行政系統",
    icon: BusinessIcon,
    state: "pageCollapse2",
    identities: ["STAFF"],
    views: [
      {
        path: "/HR-manage",
        name: "人事管理",
        icon: PeopleAltIcon,
        component: HRmanage,
        layout: "/console",
      },
      {
        path: "/online-users",
        name: "線上人數",
        icon: PersonPinIcon,
        component: OnlineUsers,
        layout: "/console",
      },
      {
        path: "/rent-obj-manage",
        name: "租賃物件管理",
        icon: FileCopyIcon,
        component: RentObjManage,
        layout: "/console",
      },
      {
        path: "/renter-manage",
        name: "租賃客戶管理",
        icon: PermContactCalendarIcon,
        component: RenterManage,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "客戶系統",
    icon: AccountBoxIcon,
    state: "pageCollapse3",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      // {
      //   path: "/customer-manage",
      //   name: "客戶管理",
      //   icon: AccountCircleIcon,
      //   component: CustomerManage,
      //   layout: "/console",
      // },
      // {
      //   path: "/original-customer",
      //   name: "原始客戶",
      //   icon: FolderSharedIcon,
      //   component: OriginalCustomer,
      //   layout: "/console",
      // },
      // {
      //   path: "/customer-reserve",
      //   name: "客戶預約",
      //   icon: ContactPhoneIcon,
      //   component: CustomerReserve,
      //   layout: "/console",
      // },
      {
        path: "/customer-center",
        name: "客戶中心",
        icon: HomeIcon,
        component: CustomerCenter,
        layout: "/console",
      },
      // {
      //   path: "/pend-customer",
      //   name: "待領客戶",
      //   icon: HourglassEmptyIcon,
      //   component: PendCustomer,
      //   layout: "/console",
      // },
      {
        path: "/miss-customer",
        name: "無緣客戶",
        icon: PersonAddDisabledIcon,
        component: MissCustomer,
        layout: "/console",
      },
      {
        path: "/customer-analyze",
        name: "潛在客戶分析",
        icon: PollIcon,
        component: CustomerAnalyze,
        layout: "/console",
      },
      {
        path: "/customer-statistics",
        name: "全店客戶統計",
        icon: GroupIcon,
        component: CustomerStatistics,
        layout: "/console",
      },
      {
        path: "/member-manage",
        name: "會員管理",
        icon: ContactsIcon,
        component: MemberManage,
        layout: "/console",
      },
      {
        path: "/picture-manage",
        name: "整屋管理",
        icon: ImageIcon,
        component: PictureManage,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "物件系統",
    icon: Description,
    state: "pageCollapse4",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      {
        path: "/sale-obj",
        name: "法拍屋查詢",
        icon: Search,
        component: SaleObj,
        layout: "/console",
      },
      {
        path: "/new-favorite",
        name: "我的追蹤物件",
        icon: TrackChanges,
        component: NewFavorite,
        layout: "/console",
      },
      {
        path: "/calendar4",
        name: "法拍行事曆",
        icon: EventNote,
        component: Calendar4,
        layout: "/console",
      },
      {
        path: "/apartmentInf",
        name: "社區大樓查詢",
        icon: Apartment,
        component: ApartmentInf,
        layout: "/console",
      },
      {
        path: "/statistical",
        name: "物件統計分析",
        icon: DonutSmall,
        component: Statistical,
        layout: "/console",
      },
      {
        path: "/obj-check",
        name: "物件擷取檢核",
        icon: CheckCircle,
        component: ObjCheck,
        layout: "/console",
      },
      {
        path: "/obj-report",
        name: "物件錯誤回報",
        icon: ErrorIcon,
        component: ObjErrorReport,
        layout: "/console",
      },
      {
        path: "/obj-record",
        name: "物件修正紀錄",
        icon: EditIcon,
        component: ObjEditRecord,
        layout: "/console",
      },
      {
        path: "/crawler-record",
        name: "爬蟲執行紀錄",
        icon: ReorderIcon,
        component: CrawlerRecord,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "個人秘書",
    icon: PermIdentityIcon,
    state: "pageCollapse5",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      {
        path: "/assignments",
        name: "交辦事項",
        icon: Search,
        component: Assignments,
        layout: "/console",
      },
      {
        path: "/personal-message",
        name: "個人訊息",
        icon: FeaturedPlayListIcon,
        component: PersonalMessage,
        layout: "/console",
      },
      {
        path: "/leave-apply",
        name: "請假申請",
        icon: EventBusyIcon,
        component: LeaveApply,
        layout: "/console",
      },
      {
        path: "/personal-calendar",
        name: "個人行事曆",
        icon: EventNoteIcon,
        component: PersonalCalendar,
        layout: "/console",
      },
      {
        path: "/vendor-contact",
        name: "廠商聯絡簿",
        icon: ListAltIcon,
        component: VendorContact,
        layout: "/console",
      },
      {
        path: "/work-report",
        name: "每日工作回報",
        icon: WorkIcon,
        component: WorkReport,
        layout: "/console",
      },
      {
        path: "/business-report",
        name: "業務工作回報",
        icon: WorkOutlineIcon,
        component: BusinessReport,
        layout: "/console",
      },
      {
        path: "/reset-password",
        name: "修改密碼",
        icon: VpnKeyIcon,
        component: ResetPassword,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "報名系統",
    icon: PlaylistAddIcon,
    state: "pageCollapse6",
    identities: ["STAFF"],
    views: [
      {
        path: "/course-announcement",
        name: "課程公告",
        icon: BookIcon,
        component: CourseAnnouncement,
        layout: "/console",
      },
      {
        path: "/activity-announcement",
        name: "活動公告",
        icon: EventAvailableIcon,
        component: ActivityAnnouncement,
        layout: "/console",
      },
      {
        path: "/student-manage",
        name: "學員管理",
        icon: FaceIcon,
        component: StudentManage,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "教學中心",
    icon: LocationCityIcon,
    state: "pageCollapse7",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      {
        path: "/system-teaching",
        name: "系統教學",
        icon: PersonalVideoIcon,
        component: SystemTeaching,
        layout: "/console",
      },
      {
        path: "/sale-secret",
        name: "法拍秘笈",
        icon: MenuBookIcon,
        component: SaleSecret,
        layout: "/console",
      },
      {
        path: "/CIS-area",
        name: "CIS專區",
        icon: GradeIcon,
        component: CISArea,
        layout: "/console",
      },
      {
        path: "/file-share",
        name: "文件共用區",
        icon: FilterIcon,
        component: FileShare,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "專屬網站",
    icon: HttpIcon,
    state: "pageCollapse8",
    identities: ["STAFF", "FRANCHISEE"],
    views: [
      {
        path: "/exclusive-web",
        name: "專屬網站管理",
        icon: ImportantDevicesIcon,
        component: ExclusiveWeb,
        layout: "/console",
      },
    ],
  },
  {
    collapse: true,
    name: "簡訊系統",
    icon: MailOutlineIcon,
    state: "pageCollapse9",
    identities: ["STAFF"],
    views: [
      {
        path: "/send-record",
        name: "發送紀錄",
        icon: ContactMailIcon,
        component: SendRecord,
        layout: "/console",
      },
      {
        path: "/points-store",
        name: "點數儲值",
        icon: AttachMoneyIcon,
        component: PointsStore,
        layout: "/console",
      },
    ],
  },
];

export default dashRoutes;
